<template>
  <head>
    <title>Eatfresh</title>
  </head>
  <Toast />

  <router-view />
</template>

<script setup lang="ts"></script>
